import axiosClient from './axiosClient';

const permissionApi = {
  // lay danh sach quyen
  getPermissionList: (params) => {
    const url = '/permission';
    return axiosClient.get(url, params);
  },
  createPermission: (params) => {
    const url = 'permission/create'
    return axiosClient.post(url, params);
  },
  updatePermission: (permissionId, params) => {
    const url = `permission/${permissionId}`
    return axiosClient.put(url, params);
  },
  deletePermission: (permissionId) => {
    const url = `/permission/${permissionId}`;
    return axiosClient.delete(url);
  },
  setUserPermission: (params) => {
    const url = 'permission/setUserPermission';
    return axiosClient.post(url, params);
  },
};

export default permissionApi; 
